import React, { useContext, useEffect, useRef, useState } from "react";
// import "./Communities.css";
// import Community from "src/Assets/images/Community-1.png"
import Link from "src/Assets/images/link.svg";
import Crown from "src/Assets/images/moderator1.svg";
import SecondaryModrator from "src/Assets/images/secondarymoderator.svg";
import Member from "src/Assets/images/crown.svg";
import MakeDefault from "src/Assets/images/Default.svg";
import setDefault from "src/Assets/images/setDefault.png";
import { useSelector, useDispatch } from "react-redux";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";
import API from "src/network";
import style from "./SignIn.module.css";
// import UserList from "./UserList";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import { IoMdClose } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 550,
  },
  maxHeight: "80vh",
  overflowY: "auto",
  bgcolor: "#f3f2f0",
  border: "none",
  borderRadius: "0 0 20px 20px",
  px: 0, // padding left + right
  py: 0, // padding top + bottom
};

function DefaultCommunityChangePage(props) {
  const { isUserBlocked, onCloseDefaultCommunitykModal, userDetails } = props;
  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const dispatch = useDispatch();
  // const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [communityId, setCommunityId] = useState(null);
  const [openMembersModal, setOpenMembersModal] = useState(false);
  const [confModalVisible, setConfModalVisible] = useState(null);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);
  const communityContext = useContext(CommunityContext);
  const history = useHistory();

  const unfollowCommunity = (id, tenantName) => {
    setShowUnfollowAlert({
      id,
      tenantName,
    });
  };

  const changeFollowHandler = async (id, tentId) => {
    let formData = new FormData();
    formData.append("communityID", id);
    formData.append("communityName", tentId);
    formData.append("followStat", "0");
    formData.append("sourceApp", "WebApp");
    await API.followCommunity(formData);
    dispatch(SignInActions.fetchloginUser());
  };

  const makeDefaultHandler = async (id, commName) => {
    const data = new FormData();
    data.append("userDefaultTenantId", id);
    const res = await API.updateDefaultTenant(data);
    if (res?.data?.status === "Community updated successfully") {
      communityContext?.onChangeCommunity({
        tenantId: id,
        tenantName: commName,
      });
      Cookies.set("signInStatus", true);
      history.push("/Home");
    }
  };

  const onClose = () => {
    setConfModalVisible(null);
  };

  const somethingWentWrong = () => {
    setConfModalVisible({
      open: true,
      type: "error",
      title: "Something went wrong!",
      acceptLabel: "Ok",
      onAccept: onClose,
    });
  };

  const makeAsModerator = async (community) => {
    const moderatorRestrictedStatus = community?.moderatorRestrictedStatus;
    const hasPermission = String(moderatorRestrictedStatus) === "0";
    if (!hasPermission) {
      setConfModalVisible({
        open: true,
        type: "error",
        title: "This Community is not adding any moderator at this time",
        acceptLabel: "Ok",
        onAccept: onClose,
      });
      return;
    }

    try {
      const { User_ID } = userDetails?.userData || {};
      const formData = new FormData();
      formData.append("tenantId", community?.id);
      formData.append("requstFor", 0);
      const response = await API.raiseModeratorRequest(formData);
      if (response?.data?.status === "Request sent successfully") {
        dispatch(SignInActions.fetchloginUser());
        setConfModalVisible({
          open: true,
          type: "success",
          title: `Your request to be a moderator in ${community?.userFollowCommunityName} was sent successfully`,
          acceptLabel: "Ok",
          onAccept: onClose,
        });
      } else {
        somethingWentWrong();
      }
    } catch (e) {
      console.error(e);
      somethingWentWrong();
    }
  };

  const confirmationForUnsubscribe = (community) => {
    setCommunityId(community?.id);
    setConfModalVisible({
      open: true,
      type: "warning",
      title: "Are you sure you want to unsubscribe from the moderator role?",
      rejectLabel: "Cancel",
      acceptLabel: "Yes",
      onReject: onClose,
      onAccept: () => unsubscribeRole(community?.id),
    });
  };

  const unsubscribeRole = async (id) => {
    try {
      onClose(null);
      const { User_ID } = userDetails?.userData || {};
      const formData = new FormData();
      formData.append("tenantId", id);
      formData.append("rejectedIds", User_ID);
      const response = await API.inviteAsModerator(formData);
      if (response?.data?.status === "Removed Successfully") {
        dispatch(SignInActions.fetchloginUser());
        setConfModalVisible({
          open: true,
          type: "success",
          title: "Removed Successfully",
          acceptLabel: "Ok",
          onAccept: onClose,
        });
      }
    } catch (e) {
      console.error(e);
      somethingWentWrong();
    }
  };

  const changePrimaryRole = (communityId) => {
    setCommunityId(communityId);
    setOpenMembersModal(true);
  };

  const onAssignPrimaryRole = async (id) => {
    setOpenMembersModal(false);
    try {
      const formData = new FormData();
      formData.append("tenantId", communityId);
      formData.append("selectedIds", id);
      formData.append("flag", "forPm");
      console.log(formData);
      const response = await API.inviteAsModerator(formData);
      setConfModalVisible({
        open: true,
        type: "success",
        title: response?.data?.status,
        acceptLabel: "Ok",
        onAccept: onClose,
      });

      // setUserData(response.data.userList);
      // setUnsubscribePrimary(true);
    } catch (e) {
      console.error(e);
      somethingWentWrong();
    }
  };

  const clickToCopy = async () => {
    const url = process.env.REACT_APP_SERVICES_API;
    try {
      // Copy the link to the clipboard
      await navigator.clipboard.writeText(
        `${url}/user/communityurl.html?tid=174`,
      );
      // Show an alert
      alert("Link copied!");
    } catch (error) {
      console.error("Error copying to clipboard:", error);
    }
  };

  return (
    <div>
      <Modal
        open={isUserBlocked}
        // onClose={onCloseDefaultCommunitykModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          onCloseDefaultCommunitykModal();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className={style.defaultCommunityChangeModal}>
            <div className={style.defaultCommunityMessageContainer}>
              {userDetails?.userData?.communityStatus === "communityBlocked" ? (
                <h5
                  style={{ color: "red", fontSize: "17px", lineHeight: "1.5" }}
                >
                  Access to your default community has been blocked by the
                  moderator. Choose a new default community to continue Sign In.
                </h5>
              ) : (
                <h5
                  style={{ color: "red", fontSize: "17px", lineHeight: "1.5" }}
                >
                  Your Default Community is Inactive. Choose a new default
                  community to continue Sign In.
                </h5>
              )}
              <button
                type="button"
                onClick={() => onCloseDefaultCommunitykModal()}
              >
                <IoMdClose />
              </button>
            </div>
            {userDetails && Object.keys(userDetails).length !== 0 ? (
              userDetails.userData &&
              Object.keys(userDetails.userData).length !== 0 ? (
                <div className={style.defaultCommunityListMainContainer}>
                  {userDetails?.userData?.communityFollowNames
                    ?.filter((result) => Number(result?.status) !== 2)
                    ?.map((result) => (
                      <div
                        className={style.defaultCommunityListContainer}
                        key={`key-id-${result.id}`}
                      >
                        <img
                          src={` ${profileImagePath}${result.thumbnailLogo}`}
                          alt="CommunityImage"
                          className="CommunityImage"
                          style={{ borderRadius: "13px" }}
                        />
                        <div className="Community-Details">
                          <p className="title">
                            {result.userFollowCommunityName}{" "}
                          </p>
                          <div className={style.buttonContainer}>
                            {result.status > 0 ? (
                              <button
                                className="Unfollow"
                                disabled={true}
                                onClick={() =>
                                  unfollowCommunity(
                                    result.id,
                                    result.userFollowCommunityName,
                                  )
                                }
                              >
                                Unfollow{" "}
                              </button>
                            ) : (
                              <button disabled={true} className="Unfollow">
                                follow
                              </button>
                            )}
                            {result.ispm === 1 ? (
                              <button
                                className={style.actions}
                                onClick={() => changePrimaryRole(result.id)}
                                disabled={true}
                                style={{ cursor: "not-allowed" }}
                              >
                                <img src={Crown} alt="Modreator" />
                              </button>
                            ) : result.ispm === 0 &&
                              result.moderatorStatus === 1 ? (
                              <button
                                className={style.actions}
                                onClick={() =>
                                  confirmationForUnsubscribe(result)
                                }
                                disabled={true}
                                style={{ cursor: "not-allowed" }}
                              >
                                <img
                                  src={SecondaryModrator}
                                  alt="SecondaryModrato"
                                />
                              </button>
                            ) : (
                              <button
                                className={style.actions}
                                onClick={() => makeAsModerator(result)}
                                disabled={true}
                                style={{ cursor: "not-allowed" }}
                              >
                                <img src={Member} alt="Member" />
                              </button>
                            )}
                            {Number(result?.status) === 2 ? (
                              <Tooltip title="Your default community is blocked — please choose another">
                                <span>
                                  <button
                                    className={style.actions}
                                    disabled={true}
                                  >
                                    <img
                                      src={MakeDefault}
                                      alt="default-community"
                                    />
                                  </button>
                                </span>
                              </Tooltip>
                            ) : (
                              <Tooltip
                                title="Make as a Default Community"
                                arrow
                              >
                                <button
                                  className={style.actions}
                                  onClick={() =>
                                    makeDefaultHandler(
                                      result.id,
                                      result.userFollowCommunityName,
                                    )
                                  }
                                >
                                  <img src={setDefault} alt="makedefault" />
                                </button>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    marginTop: "100px",
                    marginBottom: "40px",
                  }}
                >
                  <CircularProgress size={30} />
                </div>
              )
            ) : (
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "center",
                  marginTop: "100px",
                  marginBottom: "40px",
                }}
              >
                <CircularProgress size={30} />
              </div>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}
export default DefaultCommunityChangePage;
